// eslint-disable-next-line simple-import-sort/imports
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import imgBack from '@/assets/home/back.webp';
import Storage from '@/utils/Storage';
import styles from './styles.module.less';
import { ACCESS_TOKEN_KEY, ACCESS_USERID_KEY } from '@/constant/config';
import { exitFullscreen, fullScreen } from '@/utils/fullscreen';
import { gameStore } from '@/stores/game';
import { globalStore } from '@/stores/store';
import { modalStore } from '@/stores/modal';
import { notify } from '../modal/NotificationInGame';
import { useDocumentVisibility } from 'ahooks';
import { useLocation, useNavigate } from 'react-router-dom';
import BlurryLoadingImage from '@/components/progressive-img';
import Loading from './api_loading';
import { isFirstEntryAtom } from '@/jotai/user';
import { useAtomValue, useSetAtom } from 'jotai';
import { emitterAtom } from '@/jotai/emitter';
import { getGamesUrl } from '@/utils/img';
import { sleep } from '@/utils/utils';
import { savePPgameSound } from '@/api/user';

export const removeGame = () => {
  const parent = document.querySelector('#game_container');
  const iframe = document.querySelector('#game_iframe');
  if (iframe) {
    parent?.removeChild(iframe);
  }
  removeApiGame();
};

const removeApiGame = () => {
  const container = document.querySelector('#game_api_container');
  // 移除iframe
  const iframe = document.querySelector('#game_api_iframe');
  // container?.classList.remove(styles.visible);
  iframe && container?.removeChild(iframe);
};

function initPostMessage(callback: (event: MessageEvent<any>) => void) {
  window.addEventListener('message', callback, false);
}

const Play = ({ visible }: { visible: boolean }) => {
  const navigate = useNavigate();
  const { initialState } = globalStore;
  const visibility = useDocumentVisibility();
  const { pathname } = useLocation();
  const [apiGameVisible, setApiGameVisible] = useState(false);
  const [apiGameLoading, setApiGameLoading] = useState(false);
  const [inHistory, setInHistory] = useState(false);
  const setIsFirstEntry = useSetAtom(isFirstEntryAtom);
  const emitter = useAtomValue(emitterAtom);
  const isFishGame = (new URLSearchParams(Storage.get('PLAY_GAME')).get('isFishGame') || '') === '1';
  const gamepack = new URLSearchParams(Storage.get('PLAY_GAME')).get('gamekind') || '';

  emitter.useSubscription(({ type }) => {
    if (type === 'czsuccess') {
      /* 捕鱼游戏内充值成功 */
      if (isFishGame && globalStore?.initialState?.viplevel === 0) {
        exitFullscreen();
        notify.openConfirm({
          title: 'Recharge Complete! Check your balance in the lobby. Click OK to exit.',
          onConfirm: async () => {
            notify.closeConfirm();
            await handleExitGame();
          }
        });
      }
    }
  });
  useEffect(() => {
    if (pathname === '/play') {
      if (!window?.privateConfig?.noBgm) gameStore.stopBgm();
      if (gameStore.showGame && visibility === 'hidden') {
        gameStore.hideGame();
      } else {
        gameStore.showGameF();
      }
    }
  }, [pathname, visibility]);

  // 将退出游戏的逻辑抽取成一个独立函数
  const handleExitGame = async (data?: any) => {
    // 执行退出游戏
    await gameStore.exitGame(data);
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    // 重置首次进入状态
    setIsFirstEntry(false);

    // 导航回游戏大厅
    if (data?.showMsgType) {
      navigate('/game', { replace: true });
    } else {
      navigate('/game');
    }

    // 刷新余额
    // await globalStore.fetchBalance();

    // 捕鱼游戏特殊处理
    if (isFishGame) {
      await sleep(1000);
      await globalStore.fetchBalance();
      await modalStore.openFishOutModal({ img: getGamesUrl(gamepack) });
    }

    // 启用退出游戏任务链
    modalStore.enableTaskChainByExitGame();
  };

  const messageCallback = async (event: MessageEvent<any>) => {
    console.log('messageCallback', event.data);
    if (typeof event.data === 'string') {
      try {
        console.log('messageCallback', event.data);
        const data = JSON.parse(event.data);
        if (data?.method === 'back') {
          await handleExitGame(data);
          return;
        }
      } catch (error) {
        console.error('parse message error', error);
      }
    }

    const { type, data, event_name, name = '' } = event.data;
    console.log('receive message', event.data);
    if (type === 'bankruptcy_tips') {
      if (globalStore.initialState.viplevel === 0) {
        exitFullscreen();
        notify.open({
          title: 'Te has quedado sin fichas. Recarga para continuar jugando!',
          onConfirm: () => {
            navigate('/recharge?type=1');
            gameStore.hideGame();
            notify.close();
          }
        });
      } else {
        modalStore.openHorizontalPochan();
      }
    }

    // 埋点上报
    if (type === 'gtag') {
      if (!window.localStorage.getItem(`${event_name}_loading`)) {
        window.localStorage.setItem(`${event_name}_loading`, '1');
      }
    }

    // 退出操作
    if (type === 'exit' || name === 'gameQuit') {
      await handleExitGame(data);
    }

    // 游戏内充值
    if (type === 'recharge') {
      navigate('/recharge?type=1');
      gameStore.hideGame();
    }
    if (type === 'help') {
      navigate(`/game/help?url=${encodeURIComponent(data.url)}`);
      gameStore.hideGame();
    }

    if (type === 'logout') {
      await gameStore.exitGame();
      globalStore.logout();
    }

    // api游戏获取链接
    if (type === 'open_api_game') {
      const url = data.url;
      openApiGame(url);
    }
    // api游戏打开记录
    if (type === 'open_history') {
      setInHistory(true);
    }
    // api游戏关闭记录
    if (type === 'close_history') {
      setInHistory(false);
    }
  };

  const loadgame = (): Promise<{
    iframe: HTMLIFrameElement;
    type: 'old' | 'new';
  }> => {
    const hasIframe = document.querySelector('#game_iframe');
    if (hasIframe) {
      initPostMessage(messageCallback);
      return Promise.resolve({
        iframe: hasIframe as HTMLIFrameElement,
        type: 'old'
      });
    }
    return new Promise(resolve => {
      const iframe = document.createElement('iframe');
      iframe.src = Storage.get('PLAY_GAME');
      iframe.id = 'game_iframe';
      iframe.addEventListener('error', e => {
        console.log('iframe error', e);
      });
      document.querySelector('#game_container')?.appendChild(iframe);
      const isVip = (new URLSearchParams(Storage.get('PLAY_GAME')).get('isVipGame') || '') === 'true';

      !isVip && fullScreen(iframe);

      initPostMessage(messageCallback);

      iframe.onload = function () {
        resolve({
          iframe,
          type: 'new'
        });
      };
    });
  };

  // 打开api 游戏
  const openApiGame = (url: string) => {
    const container = document.querySelector('#game_api_container');
    // 移除旧的iframe
    const oldIframe = document.querySelector('#game_api_iframe');
    oldIframe && container?.removeChild?.(oldIframe);

    const iframe = document.createElement('iframe');
    iframe.id = 'game_api_iframe';
    iframe.name = 'YuFrame1'; // 用于捕鱼api游戏的返回
    iframe.addEventListener('error', e => {
      console.error('error', e);
    });
    if (!isFishGame) {
      iframe.src = url;
    }

    //启动游戏前先设置一下pp游戏的音效开关
    savePPgameSound(Storage.getByUser('MUSIC_STATE', true));

    iframe.onload = () => {
      setApiGameLoading(false);
      console.log('-------------------------------');
      const state = Storage.getByUser('MUSIC_STATE', true) ? 'true' : 'false';
      iframe?.contentWindow?.postMessage?.(
        {
          name: 'close-button',
          content: `localStorage.setItem('setting_menu$prefkeysep$soundOn', '${state}');`
        },
        '*'
      );
    };
    container?.appendChild?.(iframe);
    if (isFishGame) {
      // 创建一个临时表单进行POST请求
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      form.target = 'YuFrame1';
      form.style.display = 'none';

      // 添加表单到文档中并提交¸
      document.body.appendChild(form);
      form.submit();
      // 提交后移除表单
      document.body.removeChild(form);
    }
    fullScreen(container);
    setApiGameVisible(true);
    setApiGameLoading(true);
  };

  const exitApiGame = () => {
    handleExitGame();
    setApiGameVisible(false);
  };

  useEffect(() => {
    if (!visible) return;

    // const handler = () => {
    //   const width = document.documentElement.clientWidth;
    //   const height = document.documentElement.clientHeight;
    //   const targetDom = document.querySelector('#game_container') as HTMLDivElement;
    //   if (!targetDom) return;
    //   // 如果宽度比高度大，则认为处于横屏状态
    //   // 也可以获取 window.orientation 方向来判断屏幕状态
    //   if (width > height) {
    //     targetDom.style.position = 'fixed';
    //     targetDom.style.width = `${width}px`;
    //     targetDom.style.height = `${height}px`;
    //     targetDom.style.left = `${0}px`;
    //     targetDom.style.top = `${0}px`;
    //     targetDom.style.transform = 'none';
    //     targetDom.style.transformOrigin = '50% 50%';
    //   } else {
    //     targetDom.style.position = 'fixed';
    //     targetDom.style.width = `${height}px`;
    //     targetDom.style.height = `${width}px`;
    //     targetDom.style.left = `${0 - (height - width) / 2}px`;
    //     targetDom.style.top = `${(height - width) / 2}px`;
    //     targetDom.style.transform = 'rotate(90deg)';
    //     targetDom.style.transformOrigin = '50% 50%';
    //   }
    // };
    // const handleResize = () => {
    //   setTimeout(() => {
    //     handler();
    //   }, 300);
    // };

    // handler();
    // window.addEventListener('resize', handleResize);

    loadgame().then(({ iframe, type }) => {
      if (type === 'new') {
        setTimeout(() => {
          iframe?.contentWindow?.postMessage?.(
            {
              type: 'firstEntry',
              data: {
                userid: Storage.getAccess(ACCESS_USERID_KEY),
                token: Storage.getAccess(ACCESS_TOKEN_KEY),
                score: initialState?.score
              }
            },
            '*'
          );
        }, 500);
      }
    });

    return () => {
      console.log('remove event');
      // window.removeEventListener('resize', handleResize);
      window.removeEventListener('message', messageCallback);
    };
  }, [visible]);

  useEffect(() => {
    const isVipGame = new URLSearchParams(Storage.get('PLAY_GAME')).get('isVipGame') || '';
    const apiContainerVisible = visible && isVipGame === 'true';
    setApiGameVisible(apiContainerVisible);
    setApiGameLoading(apiContainerVisible);
  }, [visible]);

  return (
    <>
      <div
        data-sound-disabled="1"
        className={classNames(styles.box, { [styles.visible]: visible })}
        id="game_container"
      ></div>
      {/* api 游戏 */}
      <div
        data-sound-disabled="1"
        className={classNames(styles.box, { [styles.visible]: apiGameVisible })}
        id="game_api_container"
      >
        <BlurryLoadingImage
          loading="lazy"
          style={{
            display: !inHistory ? 'block' : 'none'
          }}
          src={imgBack}
          alt=""
          className={styles.close}
          onClick={() => exitApiGame()}
        />
        {apiGameLoading ? <Loading /> : null}
      </div>
    </>
  );
};

export default Play;
